import colors from '../../../../../../config/colors'

export const CHART_HEIGHT = 300
export const BAR_WIDTH = 8
export const BAR_BORDER_RADIUS: [number, number, number, number] = [2, 2, 0, 0]
export const STROKE_COLOR = FinvizSettings.hasDarkTheme ? colors.gray[700] : colors.gray[100]
export const LINE_COLOR = FinvizSettings.hasDarkTheme ? colors.blue[400] : colors.blue[400]
export const SALE_BAR_COLOR = colors.red[400]
export const BUY_BAR_COLOR = colors.green[400]
export const Y_TICK_STYLE = {
  fontSize: 10,
  fontWeight: 500,
  fill: FinvizSettings.hasDarkTheme ? colors.gray[300] : colors.gray[500],
}
export const X_TICK_STYLE = {
  fontSize: 10,
  fontWeight: 400,
  fill: FinvizSettings.hasDarkTheme ? colors.gray[300] : colors.gray[500],
}
export const TOOLTIP_WRAPPER_STYLE = { outline: 'none', zIndex: 10 }
export const CURSOR_STYLE = {
  border: 0,
  stroke: 0,
  fill: FinvizSettings.hasDarkTheme ? colors.gray[700] : colors.gray[50],
  opacity: 0.65,
}
export const TRANSPARENT_CURSOR = { opacity: 0 }

export enum BarType {
  Buy = 'Buy',
  Sale = 'Sale',
}

export const BarColorMap: Record<BarType, string> = {
  [BarType.Buy]: BUY_BAR_COLOR,
  [BarType.Sale]: SALE_BAR_COLOR,
}

export const BarLabelMap: Record<BarType, string> = {
  [BarType.Buy]: 'Insider Buy Volume',
  [BarType.Sale]: 'Insider Sells Volume',
}
